import { gql } from "@apollo/client";

const FILE_UPLOAD_MUTATION = gql`
  mutation (
    $file: Upload!,
    $directory: String,
  ) {
    uploadFile(
      file: $file,
      directory: $directory,
    ) {
      File_Path
      File_Ext
      File_Name
      File
    }
  }
`;

const ADD_FILE = gql`
  mutation createFileUploads(
    $Year_ID: Float!,
    $Stage: Float!,
    $File_Category: String!,
    $File_Module: String!,
    $File_Name: String!,
    $File_Path: String!,
    $Status: String!, 
    $Created_By: String!,
    $Modified_By: String!
  ) {
    createFileUploads(data: { 
      Year_ID: $Year_ID,
      Stage: $Stage,
      File_Category: $File_Category,
      File_Module: $File_Module,
      File_Name: $File_Name,
      File_Path: $File_Path,
      Status: $Status,
      Created_By: $Created_By,
      Modified_By: $Modified_By,
    }) {
      File_ID
      File_Category
      File_Module
      File_Name
      File_Path
      Status
      Created_Date
      Modified_Date
      Created_By
      Modified_By
      Year_ID {
        Year_ID
        Fiscal_Year
        Start_Date
        End_Date
        Status
        Module
        Created_Date
        Modified_Date
        Created_By
        Modified_By
      }
      Stage {
        Stage_ID
        Process_Area
        Stage
        Status
        Created_Date
        Modified_Date
        Created_By
        Modified_By
      }
    }
  } 
`;

const UPDATE_FILE = gql`
  mutation updateFileUploads(
    $File_ID: Float!,
    $Year_ID: Float!,
    $Stage: Float!,
    $File_Category: String!,
    $File_Module: String!,
    $File_Name: String!,
    $File_Path: String!,
    $Status: String!, 
    $Modified_By: String
  ) {
    updateFileUploads(
      id: $File_ID,
      data: {       
        Year_ID: $Year_ID,
        Stage: $Stage,
        File_Category: $File_Category,
        File_Module: $File_Module,
        File_Name: $File_Name,
        File_Path: $File_Path,
        Status: $Status,
        Modified_By: $Modified_By
      }
    ) {
      File_ID
      File_Category
      File_Module
      File_Name
      File_Path
      Status
      Created_Date
      Modified_Date
      Created_By
      Modified_By
      Year_ID {
        Year_ID
        Fiscal_Year
        Start_Date
        End_Date
        Status
        Module
        Created_Date
        Modified_Date
        Created_By
        Modified_By
      }
      Stage {
        Stage_ID
        Process_Area
        Stage
        Status
        Created_Date
        Modified_Date
        Created_By
        Modified_By
      }
    }
  }
`;

const DELETE_FILE = gql`
  mutation removeFileUploads(
    $File_ID: Float!
  ) {
    removeFileUploads(id: $File_ID) {
      File_ID
      File_Category
      File_Module
      File_Name
      File_Path
      Status
      Created_Date
      Modified_Date
      Created_By
      Modified_By
      Year_ID {
        Year_ID
        Fiscal_Year
        Start_Date
        End_Date
        Status
        Module
        Created_Date
        Modified_Date
        Created_By
        Modified_By
      }
      Stage {
        Stage_ID
        Process_Area
        Stage
        Status
        Created_Date
        Modified_Date
        Created_By
        Modified_By
      }
    }
  }
`;

export { FILE_UPLOAD_MUTATION, ADD_FILE, UPDATE_FILE, DELETE_FILE,  };